<template>
  <v-app dark>
    <keep-alive>
      <router-view :key="$route.fullPath"></router-view>
    </keep-alive>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>
